import { gql } from '@apollo/client';

export const GET_AUTH = gql`
  query GET_AUTH {
    auth {
      token
      isLoggedIn
      me {
        netId
        authenticationMode
      }
      loading
    }
  }
`;

export const LOGIN = gql`
  mutation LOGIN($input: LoginInput) {
    login(input: $input) {
      token
      me {
        id
        netId
        name
        authenticationMode
        email
        roles {
          role {
            id
            name
            scopes {
              type
              level
            }
          }
          department {
            id
          }
          faculty {
            id
          }
        }
        passRolesTo {
          id
          from
          to
          role {
            id
            name
            scopes {
              type
              level
            }
          }
        }
      }
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation REFRESH_TOKEN($init: Boolean!) {
    refreshToken(init: $init) {
      token
      me {
        id
        netId
        name
        authenticationMode
        email
        roles {
          role {
            id
            name
            scopes {
              type
              level
            }
          }
          department {
            id
          }
          faculty {
            id
          }
        }
        passRolesTo {
          id
          from
          to
          role {
            id
            name
            scopes {
              type
              level
            }
          }
        }
      }
    }
  }
`;

export const LOGOUT = gql`
  mutation LOGOUT {
    logout
  }
`;

export const GET_ME = gql`
  query GET_ME {
    me {
      id
      netId
      name
      email
      faculty {
        id
        name
        abbreviation
      }
      department {
        id
        name
        abbreviation
      }
      userFromHroStaff {
        id
        position
      }
      roles {
        role {
          id
          name
        }
        faculty {
          id
          name
          abbreviation
        }
        department {
          id
          name
          abbreviation
        }
      }
      passRolesTo {
        id
        passFrom {
          id
          title
          name
          netId
        }
        from
        to
        role {
          id
          name
        }
        faculty {
          id
          name
          abbreviation
        }
        department {
          id
          name
          abbreviation
        }
        disabled
        deleted
      }
      passRolesFrom {
        id
        passTo {
          netId
          name
          id
        }
        from
        to
        role {
          id
          name
        }
        faculty {
          id
          name
          abbreviation
        }
        department {
          id
          name
          abbreviation
        }
        disabled
        deleted
      }
    }
  }
`;

export const MY_SCOPE_TYPES_IN_PROJECT = gql`
  query MY_SCOPE_TYPES_IN_PROJECT($projectId: ID!) {
    myScopeTypesInProject(projectId: $projectId) {
      viewProject
      scopeTypes
    }
  }
`;

export const IS_CURRENT_APPOINTED_APPROVER = gql`
  query IS_CURRENT_APPOINTED_APPROVER(
    $id: ID!
    $applicationType: ApplicationType!
  ) {
    isCurrentAppointedApprover(id: $id, applicationType: $applicationType)
  }
`;

export const GET_MY_SCOPE_TYPES = gql`
  query GET_MY_SCOPE_TYPES {
    myScopeTypes
  }
`;

export const GET_MY_ROLES_AND_CURRENT_USER_ROLE = gql`
  query GET_MY_ROLES_AND_CURRENT_USER_ROLE {
    myCurrentUserRole {
      ... on UserRole {
        id
        department {
          id
        }
        faculty {
          id
        }
        role {
          id
          scopes {
            type
            level
          }
        }
      }
      ... on PassRole {
        id
        department {
          id
        }
        faculty {
          id
        }
        role {
          id
          name
        }
      }
    }
    me {
      id
      assignedRoles {
        ... on UserRole {
          id
          role {
            id
            name
          }
          department {
            id
            name
          }
          faculty {
            id
            name
          }
        }
        ... on PassRole {
          id
          role {
            id
            name
          }
          department {
            id
            name
          }
          faculty {
            id
            name
          }
          passFrom {
            id
            title
            name
            netId
          }
        }
      }
    }
  }
`;

export const GET_MY_CURRENT_USER_ROLE = gql`
  query GET_MY_CURRENT_USER_ROLE {
    myCurrentUserRole {
      ... on UserRole {
        id
        faculty {
          id
        }
        department {
          id
          controlType
        }
      }
      ... on PassRole {
        id
        faculty {
          id
        }
        department {
          id
          controlType
        }
        role {
          name
        }
      }
    }
  }
`;

export const GET_MY_ROLES = gql`
  query GET_MY_ROLES {
    me {
      id
      assignedRoles {
        ... on UserRole {
          id
          role {
            id
            name
          }
          department {
            id
            name
          }
          faculty {
            id
            name
          }
        }
        ... on PassRole {
          id
          role {
            id
            name
          }
          department {
            id
            name
          }
          faculty {
            id
            name
          }
          passFrom {
            id
            title
            name
            netId
          }
        }
      }
    }
  }
`;

export const SELECT_USER_ROLE = gql`
  mutation SELECT_USER_ROLE($input: SelectUserRoleInput!) {
    selectUserRole(input: $input) {
      token
      selectedUserRole {
        ... on UserRole {
          id
          role {
            id
            name
          }
          department {
            id
            name
          }
          faculty {
            id
            name
          }
        }
        ... on PassRole {
          id
          role {
            id
            name
          }
          department {
            id
            name
          }
          faculty {
            id
            name
          }
          passFrom {
            id
            title
            name
            netId
          }
        }
      }
    }
  }
`;
